module.exports = __webpack_public_path__ + "media/site/images/icons/iot-icon-25b73a658d89819f35e58fa69ee1a4c1.svg";